import UnsentImagePreview from '@/common/components/adjusterReport/previewImages/UnsentImagePreview';
import UploadProgressBarModal from '@/common/components/uploadProgressBar/UploadProgressBarModal';
import useModal from '@/common/hooks/useModal';
import getVehicleTypeQueryOption from '@/common/queries/getVehicleType/getVehicleTypeQueryOPtion';
import useToast from '@/common/store/alert/useToast';
import { AddDamagedVehicleAdjusterQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/addDamagedVehicleAdjuster/addDamagedVehicleAdjusterQuery.type';
import { useAddDamagedVehicleAdjusterQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/addDamagedVehicleAdjuster/addDamagedVehicleAdjusterQueryOptions';
import { getDamagedAdjusterImagesQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterImages/getDamagedAdjusterImagesQueryOptions';
import useDamagedPoints from '@/modules/adjusterReportModules/IncidentParticipants/store/damagePoints/useDamagedPoints';
import { useImageFlowStore } from '@/modules/adjusterReportModules/IncidentParticipants/store/imageFlow/useImageFlowStore';
import { UserTypeProps } from '@/modules/adjusterReportModules/IncidentParticipants/types/ParticipantType';
import { createImagesFlowPostData } from '@/modules/adjusterReportModules/IncidentParticipants/utils/createImagesFlowPostData';
// import OfflineTakePhotoConfirmationModal from '@/modules/OfflineFiles/components/modals/OfflineTakePhotoConfirmationModal';
// import useSlowNetworkDetector from '@/modules/OfflineFiles/hooks/useSlowNetworkDetector';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const VehicleImagePreview = ({
  userType,
  BackToImagesTab,
  navigateToRepeatCapturing,
  userId,
}: {
  navigateToRepeatCapturing: () => void;
  BackToImagesTab: () => void;
  userId?: string;
} & UserTypeProps) => {
  const [progress, setProgress] = useState<number>(0);
  const controllerRef = useRef<AbortController>(new AbortController());
  const { id } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { showAlert } = useToast();
  const { video, images, resetCameraStore } = useImageFlowStore();
  const { resetDamagedPoints } = useDamagedPoints();
  const { data: fileVehicleType } = useQuery(
    getVehicleTypeQueryOption({
      damaged_pk: userType === 'damaged' ? userId : undefined,
      file_pk: id!,
    }),
  );
  // const {
  //   updateIsSlowDetectorRunningState,
  //   // isSlowDetectorRunningRef,
  //   // calculateUploadSpeed,
  //   cancelDetection,
  //   offlineTakePhotoModal,
  //   // slowNetworkDetector,
  // } = useSlowNetworkDetector();
  const {
    closeModal: uploadProgressCloseModal,
    open: uploadProgressOpen,
    openModal: uploadProgressOpenModal,
  } = useModal();

  const { mutate } = useAddDamagedVehicleAdjusterQueryOptions();

  const handleSubmit = () => {
    uploadProgressOpenModal();
    // slowNetworkDetector();
    const data = createImagesFlowPostData().createPostData({ images, video });
    const requestData: AddDamagedVehicleAdjusterQueryParamsType = {
      initial_images: data.initialImages,
      damaged_images: data.damagedImages,
      damaged_id: userId!,
      id: id!,
      participantRoleType: userType,
      vehicleType: fileVehicleType?.name!,
      onProgress: (progress: number) => {
        setProgress(Number(progress.toFixed(2)));
        // isSlowDetectorRunningRef.current &&
        //   calculateUploadSpeed({ loadedBytes });
      },
      signal: controllerRef.current.signal,
    };
    controllerRef.current.signal.onabort = () => {
      // cancelDetection();
      controllerRef.current = new AbortController();
      setProgress(0);
    };

    mutate(requestData, {
      onSuccess: onSuccessPostImages,
      onError: () => {
        closeUploadModal();
        setProgress(0);
        controllerRef.current = new AbortController();
      },
    });
  };

  const onSuccessPostImages = () => {
    queryClient.invalidateQueries({
      queryKey: getDamagedAdjusterImagesQueryOptions({
        id: +id!,
        enable: true,
        damaged_id: +userId!,
        participantRoleType: userType,
      }).queryKey,
    });
    resetDamagedPoints();
    resetCameraStore();
    uploadProgressCloseModal();

    setProgress(0);
    showAlert({
      description: 'تصاویر خودرو با موفقیت ثبت شد.',
      type: 'success',
    });
    navigate(-1);
  };
  // const tryCreateOfflineFile = () => {
  //   closeUploadModal();
  // };
  // const offlineFileCreated = () => {
  //   onSuccessPostImages();
  // };
  const repeatCapturing = () => {
    resetCameraStore();
    navigateToRepeatCapturing();
  };
  const closeUploadModal = () => {
    uploadProgressCloseModal();
    if (controllerRef.current) {
      controllerRef.current.abort();
    }
    // updateIsSlowDetectorRunningState(false);
  };

  useEffect(() => {
    if (!images.vehicleImages?.length) {
      BackToImagesTab();
    }
  }, []);
  return (
    <>
      <UnsentImagePreview
        onSubmit={handleSubmit}
        repeatCapturing={repeatCapturing}
      />
      {uploadProgressOpen && (
        <UploadProgressBarModal
          closeModal={closeUploadModal}
          open={uploadProgressOpen}
          progress={progress}
        />
      )}
      {/* <OfflineTakePhotoConfirmationModal
        closeModal={offlineTakePhotoModal.closeModal}
        open={offlineTakePhotoModal.open}
        offlineFileCreated={offlineFileCreated}
        tryCreateOfflineFile={tryCreateOfflineFile}
        imagesData={offlineTakePhotoModal.open ? { images, video } : undefined}
        userType={userType}
      /> */}
    </>
  );
};
